__turbopack_context__.v({
  "button": "ApplyStepButtons-module__MPSCaa__button",
  "container": "ApplyStepButtons-module__MPSCaa__container",
  "fadeInItems": "ApplyStepButtons-module__MPSCaa__fadeInItems",
  "spacing--lg": "ApplyStepButtons-module__MPSCaa__spacing--lg",
  "spacing--md": "ApplyStepButtons-module__MPSCaa__spacing--md",
  "spacing--sm": "ApplyStepButtons-module__MPSCaa__spacing--sm",
  "spacing--xl": "ApplyStepButtons-module__MPSCaa__spacing--xl",
  "spacing--xs": "ApplyStepButtons-module__MPSCaa__spacing--xs",
  "spacing--xxl": "ApplyStepButtons-module__MPSCaa__spacing--xxl",
  "spacing--xxs": "ApplyStepButtons-module__MPSCaa__spacing--xxs",
  "spacing--xxxl": "ApplyStepButtons-module__MPSCaa__spacing--xxxl",
  "spacing--xxxs": "ApplyStepButtons-module__MPSCaa__spacing--xxxs",
});
